import reframe from 'reframe.js';
import loadYoutubeApi from '../utils/loadYoutubeApi';

export default class Youtube {
  constructor(el) {
    const url = el.getAttribute('data-video-url');
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
    this.el = el;
    this.id = url.match(regex)[1] || null;

    this.isReady = false;
    this.onReady = this._onReady.bind(this);
    this.onReadyCallback = null;

    this.onStateChange = this._onStateChange.bind(this);
    this.onPlayCallback = null;

    loadYoutubeApi().then(this._onApiLoaded.bind(this));
  }

  play() {
    return new Promise((resolve) => {
      this.onPlayCallback = resolve;

      if (this.isReady) {
        this.player.playVideo();
      } else {
        this.onReadyCallback = this.player.playVideo;
      }
    });
  }

  unload() {
    // Reframe doesnt offer an unload method, so we'll manually remove the elements added
    if (this.frame) {
      const wrapper = this.frame.parentNode;
      const originalParent = wrapper.parentNode;

      originalParent.appendChild(this.frame);
      originalParent.removeChild(wrapper);
    }
    this.player.destroy();
  }

  _onApiLoaded() {
    this.player = new YT.Player(this.el, {
      videoId: this.id,
      playerVars: {
        modestbranding: true,
        showinfo: false,
        controls: false,
      },
      events: {
        onReady: this.onReady,
        onStateChange: this.onStateChange,
      },
    });
  }

  _onReady() {
    this.isReady = true;

    this.frame = this.player.getIframe();
    reframe(this.frame);

    if (this.onReadyCallback) {
      this.onReadyCallback();
    }
  }

  _onStateChange(event) {
    const state = event.data;

    if (
      this.onPlayCallback
      && state === window.YT.PlayerState.PLAYING
    ) {
      this.onPlayCallback();
      this.onPlayCallback = null;
    }
  }
}
